export default class JsonUtils{
  static parse(key: string, value: any){
  if (value && typeof value === 'object') {
  for (const k in value) {
  if (Object.prototype.hasOwnProperty.call(value, k)) {
  value[k] = JsonUtils.parse(k, value[k]);
}
}
}else{
  if (typeof value === 'string' && JsonUtils.isIsoDateString(value)) {
    return new Date(value);
  }else{
    return value
  }
}
return value;
}
  static isIsoDateString (value: string): boolean{
    const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}(Z|[+-]\d{2}:\d{2})$/;
    return isoDateFormat.test(value);
  }

}

